<div class="container">
  <div class="row justify-content-center text-center mt-4">
    <div class="col-md-7">
      @if (announcement) {
        <h1 class="fw-normal text-bg-dark px-5 py-2">
          {{ announcement.title }}
        </h1>
      } @else {
        <div class="text-bg-dark text-center mb-2" style="height: 60px"></div>
      }
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      @if (announcement) {
        <h5 class="text-center my-4">
          {{ announcement.start_date | date: "d 'de' MMMM, y" }}
        </h5>
      } @else {
        <div class="text-center">
          <h5 class="placeholder-glow">
            <span class="placeholder col-4"></span>
          </h5>
        </div>
      }

      @if (announcement) {
        <app-dynamic-content-viewer
          [content]="announcement.content"
          [keepOnlyConsultarConvocatoriaActions]="true"
        />
      } @else {
        <div
          class="object-fit-cover mb-4"
          style="height: 300px; background-color: #f0f0f0"
        ></div>

        <div class="text-center mb-3">
          <h6 class="placeholder-glow">
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
          </h6>
        </div>
      }
    </div>

    <div class="col-md-3"></div>
  </div>

  <h2 class="text-center">Otras convocatorias</h2>

  <div class="row g-3 justify-content-center mt-4">
    @for (announcement of announcements; track announcement.id) {
      <div class="col-md-3">
        <a [routerLink]="['/convocatoria', announcement.id]">
          <div class="card text-bg-dark" style="min-height: 300px">
            <img
              [src]="announcement.image_url"
              class="card-img object-fit-cover"
              height="180"
              alt=""
            />
            <div class="p-2">
              <h5 class="card-title">{{ announcement.title }}</h5>
              <p class="card-text">{{ announcement.start_date }}</p>
            </div>
          </div>
        </a>
      </div>
    }
  </div>
</div>
